import { acceptImageAndDoc } from "@3gaam/shared/utils/uploadAccept";
import React, { ChangeEventHandler, useRef, useState } from "react";
import { FormError } from "../../../types/error";
import Icon from "../icon";

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  error: FormError;
  value: string | undefined;
  uploading?: boolean;
};

const getFileName = (fileName?: string) => {
  if (!fileName) return;

  const splits = fileName.split("\\");
  return splits[splits.length - 1];
};

const FileField = ({
  onChange,
  onKeyDown,
  name,
  value,
  placeholder,
  className = "",
  readOnly,
  children,
  error,
  uploading: uploadingProp,
}: Props) => {
  let showError = error?.hasError && error?.dataError?.[name || ""];
  let [fileName, setFileName] = useState<string | undefined>(undefined);
  let inputRef = useRef<HTMLInputElement | null>(null);
  let _onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    if (!onChange) return;
    if (!inputRef || !inputRef.current) return;
    onChange(event);
    setFileName(inputRef.current.value);
  };

  let uploading = uploadingProp || (!!fileName && !value && !showError);
  return (
    <>
      <div className={`inp-box file-box ${showError ? "invalid-field" : ""}`}>
        <div className="file-box-placeholder">
          <div className="file-box-inp-icon">
            <Icon name="fal-fa-folder-open" />
          </div>
          <span className="file-box-inp-text">
            {uploading
              ? "در حال آپلود ..."
              : showError
              ? "انتخاب کنید"
              : getFileName(fileName) || "انتخاب کنید"}
          </span>
        </div>
        <input
          ref={inputRef}
          className={`rounded-8 form-control  ${className}`}
          type="file"
          name={name}
          onChange={_onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          readOnly={readOnly}
          accept={acceptImageAndDoc}
        />
        {children}
      </div>
      {showError && (
        <p className="text-red font-12 mt-1">
          {error?.dataError?.[name || ""]}
        </p>
      )}
    </>
  );
};

export default FileField;
